import { Validators } from "@angular/forms";
import { FormField } from "../../../core/models/form/form-field.model";

export const LOGIN_LEARNER_FORM: { [key: string]: FormField } = {
    fiscalCode: {
        id: 'fiscalCode',
        type: 'text',
        name: 'fiscalCode',
        label: 'Codice fiscale',
        placeholder: "Inserisci il tuo Codice fiscale",
        value: '',
        data: [],
        validators: [Validators.required],
        errorMessages: {
            required: "Inserire il codice fiscale."
        },
        toUppercase: true
    },
    password: {
        id: 'password',
        type: 'password',
        name: 'password',
        label: 'Password',
        placeholder: "Digita la password",
        value: '',
        data: [],
        validators: [Validators.required],
        errorMessages: {
            required: "Password obbligatoria",
            passwordNotStrong: "La password deve contenere almeno 8 caratteri, con almeno una lettera maiuscola, una minuscola, un numero e un carattere speciale "
        }
    }
}